import { useFilters } from '@/platform/hooks/useFilters';
import { FilterBar, FilterBarSearch } from '@/platform/ui';
import useDebounce from '@/react/hooks/useDebounce';
import { useEffect, useRef, useState } from 'react';

const SearchBarFilter = ({ only = [], children }) => {
    const { filters, updateFilters } = useFilters(only);
    const [search, setSearch] = useState(filters?.search || '');
    const isMounted = useRef(false);

    const debouncedSearch = useDebounce(search);

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        updateFilters('search', debouncedSearch);
    }, [debouncedSearch]);

    return (
        <FilterBar>
            {children}
            <FilterBarSearch
                value={search}
                placeholder='Zoeken...'
                onChange={value => setSearch(value)}
            />
        </FilterBar>
    );
};

export default SearchBarFilter;
